/**
 * 在线充值（四方代收 / PIX）本地缓存工具
 *
 * 支付页是外部 H5，跳转后本页会被销毁/刷新；
 * 用 localStorage 记住待支付订单和 pay_url，回到 #/Recharge 后继续轮询到账状态。
 */
export const PENDING_KEY = 'recharge_pending_order'
export const PAY_CACHE_KEY = 'recharge_pay_cache'

function readJSON(key, fallback) {
  try {
    const value = JSON.parse(localStorage.getItem(key) || 'null')
    return value === null || value === undefined ? fallback : value
  } catch (e) {
    return fallback
  }
}

function writeJSON(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch (e) {
    // 本地存储不可用时只影响续付/轮询，不影响主流程
  }
}

export function getPayCache() {
  const cache = readJSON(PAY_CACHE_KEY, {})
  return cache && typeof cache === 'object' && !Array.isArray(cache) ? cache : {}
}

export function savePayCache(order) {
  if (!order || !order.order_no || !order.pay_url) return
  const cache = getPayCache()
  cache[order.order_no] = {
    order_no: order.order_no,
    pay_url: order.pay_url,
    expire_at: Number(order.expire_at) || 0,
    created_at: Date.now()
  }
  const keys = Object.keys(cache)
    .sort((a, b) => (Number(cache[b].created_at) || 0) - (Number(cache[a].created_at) || 0))
    .slice(0, 20)
  const next = {}
  keys.forEach(key => { next[key] = cache[key] })
  writeJSON(PAY_CACHE_KEY, next)
}

export function getPendingOrder() {
  return readJSON(PENDING_KEY, null)
}

export function setPendingOrder(order) {
  if (!order || !order.order_no) return
  writeJSON(PENDING_KEY, {
    order_no: order.order_no,
    pay_url: order.pay_url || '',
    expire_at: Number(order.expire_at) || 0,
    created_at: Date.now()
  })
}

export function clearPendingOrder() {
  try {
    localStorage.removeItem(PENDING_KEY)
  } catch (e) {
    // ignore
  }
}

/** 是否已过期：expire_at 是秒级时间戳，0 表示后端未返回有效期 */
export function isOrderExpired(order) {
  if (!order || !Number(order.expire_at)) return false
  return Math.floor(Date.now() / 1000) > Number(order.expire_at)
}

/**
 * 去掉金额里的货币符号/货币代码，只保留数字和小数点
 * 后端部分接口会返回 "R$ 500.00" 这类字符串
 */
export function stripCurrency(value) {
  if (value === null || value === undefined) return ''
  return String(value)
    .replace(/R\$\s*/gi, '')
    .replace(/\b(?:BRL|MXN|USD|EUR|GBP|ARS|CLP|COP|PEN)\b/gi, '')
    .replace(/[$€£]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
}

/** 取未过期的支付地址，用于充值记录页「继续支付」 */
export function getCachedPayUrl(orderNo) {
  if (!orderNo) return ''
  const item = getPayCache()[orderNo]
  if (!item || !item.pay_url || isOrderExpired(item)) return ''
  return item.pay_url
}
